import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useBoardViewerConfigV1ControllerGet } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useFetchBoardViewerConfig = (constructionSiteId: string) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, error, isLoading, refetch } =
    useBoardViewerConfigV1ControllerGet({
      pathParams: {
        constructionSiteId,
      },
      headers: restHeaders,
    });

  return {
    segmentDrawConfigs: data?.segmentDrawConfigs ?? [],
    segmentWidth: data?.segmentWidth ?? 0,
    tunnelPositions: data?.tunnelPositions ?? [],
    defectReportTypes: data?.defectReportTypes ?? [],
    isLoading,
    error,
    refetch,
  };
};
